import type { SubscriptionBlockViewDto } from '@subscriptions/application/dtos';

/** Date the block entered churn. The API sends it per store, and never for an old churn. */
export const getBlockChurnDate = (block: Pick<SubscriptionBlockViewDto, 'inactiveSince' | 'stores'>): string | null =>
  block.inactiveSince ?? block.stores.find((store) => store.churnedAt)?.churnedAt ?? null;
